<template>
  <div class="col-sm-12 col-lg-10 mx-auto">
    <div class="mx-auto" :class="isMobile ? 'd-flex no-wrap': 'row'">
      <div class="col">
        <h3 v-if="isMobile" class="text-left text-capitalize">Ciao,{{ this.nome }}</h3>
        <h1 v-else class="text-capitalize">Ciao, {{ this.nome }}</h1>
        <div class="col-sm-12 col-lg-10 mx-auto pt-2" :class="isMobile && 'px-0'">
          <b-button
            block
            variant="primary"
            @click="goToCalendario"
            class="my-2 font-weight-bold rounded-pill py-2"
          >Consulta le prenotazioni</b-button>
        </div>
        <div
          v-if="this.notimeflag"
          class="col-sm-12 col-lg-10 mx-auto pt-2"
          :class="isMobile && 'px-0'"
        >
          <b-button
            block
            variant="secondary"
            @click="goToImpostazioni"
            class="my-2 font-weight-bold rounded-pill py-2"
          >Imposta orari di ricevimento</b-button>
        </div>
      </div>

      <div class="col-5" v-if="!isMobile">
        <FarmaLogo class="fit__img" v-if="farmacistaflag" />
        <DottorLogo class="fit__img" v-else />
      </div>
    </div>
  </div>
</template>
<script>
import DottorLogo from "@/../public/svg/dottor.svg";
import FarmaLogo from "@/../public/svg/farmacista.svg";
export default {
  name: "funzioni-professionista",
  props: ["nome", "notimeflag", "farmacistaflag"],
  components: { DottorLogo, FarmaLogo },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    }
  },
  methods: {
    goToCalendario() {
      this.$router.push({
        name: "CalendarioConsulti",
        params: { tipo: "professionista" }
      });
    },
    goToImpostazioni() {
      this.$router.push({
        name: "Profilo",
        query: { toset: "orari" }
      });
    }
  },
  created() {
    // console.log("funzioni professionista");
  }
};
</script>
<style scoped>
.fit__img {
  max-height: 250px;
}
.a {
  fill: #ffccbc;
}
.b {
  fill: #ffab91;
}
.c {
  fill: #fff;
}
.d {
  fill: #eceff1;
}
.e {
  fill: #d1c4e9;
}
.f {
  fill: #9575cd;
}
.g {
  fill: #37474f;
}
.h {
  fill: #01579b;
}
.i {
  fill: #ff8a65;
}
.j {
  fill: #263238;
}
.k {
  fill: #4f2121;
}
.l {
  fill: #792121;
}
.st0 {
  fill: #ffccbc;
}
.st1 {
  fill: #ffab91;
}
.st2 {
  fill: #ffffff;
}
.st3 {
  fill: #eceff1;
}
.st4 {
  fill: #d1c4e9;
}
.st5 {
  fill: #9575cd;
}
.st6 {
  fill: #01579b;
}
.st7 {
  fill: #37474f;
}
.st8 {
  fill: #ff8a65;
}
.st9 {
  fill: #263238;
}
.st10 {
  fill: #4f2121;
}
.st11 {
  fill: #792121;
}
.st12 {
  fill: #e52828;
}
.st13 {
  opacity: 0.43;
}
.st14 {
  fill: #1e7fc1;
}
</style>
